<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                            </span></h2>
                </v-row>
        
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5"
                >
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n5">
                            <v-text-field
                                outlined
                                :label="$t('pmkpiinclusion.kpiinclusionset')"
                                type="text"
                                ref="code"
                                v-model="formData.code"
                                :rules="[rules.required]"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="this.$t('pmkpiinclusion.description')"
                                type="text"
                                ref="description"
                                v-model="formData.description"
                                @input="updateValue"
                                :rules="[rules.required]"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="this.$t('columns.remark')"
                                type="text"
                                ref="remark"
                                v-model="formData.remark"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row v-if="isEdit">
                        <v-col cols="6" sm="6" class="blue--text">
                           {{$t('performancemanagement.kpiset')}}
                        </v-col>
                    </v-row>

                    <v-row v-if="isEdit && !loading" style="overflow-x: auto; display: block; max-width: 100%;">
                        <app-table
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader,
                                detailItem: this.KPIInclusionDetailsList,
                                kpiinclusionid: this.parentObject.kpiinclusionid
                            }"
                        />
                    </v-row>
                </v-container>


                <app-formbuttons 
                    v-bind:EditBool = this.parentObject.isEdit
                    v-on:NewPressed="newHandler"
                    v-on:SavePressed="saveHandler" 
                    v-on:DeletePressed="deleteHandler"
                    v-on:CancelPressed="cancelHandler" 
                />

            </v-form>

        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                code: this.parentObject.data.code,
                description: this.parentObject.data.description,
                remark: this.parentObject.data.remark,
                stamp: this.parentObject.data.stamp,
                userid: this.$store.getters.userId,
            },

            KPIInclusionDetailsList: [],
            loading: true,

            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.isEdit,
            search: this.parentObject.searchnew,

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('performancemanagement.kpiset'), value: 'pmkpisetcode', width: '150px', sortable: true},
                { text: this.$t('columns.company'), value: 'compnycode', width: '150px', sortable: true},
                { text: this.$t('columns.branch'), value: 'brchcode', width: '150px', sortable: true},
                { text: this.$t('columns.division'), value: 'divncode', width: '180px', sortable: true},
                { text: this.$t('columns.department'), value: 'deptcode', width: '150px', sortable: true},
                { text: this.$t('columns.section'), value: 'sectiocode', width: '100px', sortable: true},
                { text: this.$t('columns.unit'), value: 'unitcode', width: '100px', sortable: true},
                { text: this.$t('columns.employmenttype'), value: 'emptype', width: '180px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grdcode', width: '100px', sortable: true},
                { text: this.$t('columns.job'), value: 'jobcode', width: '100px', sortable: true},
                { text: this.$t('columns.position'), value: 'poscode', width: '100px', sortable: true},
            ],

        }
    },

    methods: {

        updateValue() {
            this.$emit('input', {
                code: this.formData.code,
                description: this.formData.description,
                remark: this.formData.remark,
                stamp: this.formData.stamp,
                userid: this.formData.userid,
            });
        },

        loadKPIInclusionDetails() {
            const vm = this;
            this.$store.dispatch('get', { url: '/kpiinclusiond/' + this.parentObject.kpiinclusionid })
            .then((res) => {
                vm.KPIInclusionDetailsList = res.data.rec;

                vm.loading = false;
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        newHandler() {
            this.$emit('new');
        },

        saveHandler() {
            this.$emit('save');
        },

        deleteHandler() {
            this.$emit('delete');
        },

        cancelHandler() {
            this.$router.push({name: 'kpiinclusionlist', params: { search: this.search}});
        },
    },

    mounted() {
        this.loadKPIInclusionDetails();
    }
    
}
</script>